import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { FeaturesI18N } from './webid/4.0/projects/controls/src/lib/base/model/features-i18n';

if (environment.production) {
    enableProdMode();
}

FeaturesI18N.setLocale('ru-RU');
platformBrowserDynamic().bootstrapModule(AppModule);
